'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ta_IN = require('../../date-picker/locale/ta_IN');

var _ta_IN2 = _interopRequireDefault(_ta_IN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _ta_IN2['default'];